<template>
  <div class="oaTemplate">
    <el-container
      class="fullheight"
      style="border: 1px solid #eee"
      :style="{
        height: height
      }"
    >
      <el-aside class="fullheight" :width="width" v-show="asideShow">
        <fe-oa-template-tree
          class="fe-sys-type-tree"
          highlight-current
          ref="ecoDataDicTree"
          :support-filter="supportFilter"
          :default-expand-all="isExpand"
          expand-on-click-node="false"
          @node-click="handleNodeClick"
          @setTree="setTree"
        >
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span :class="[checkCanEdit() ? 'show-ellipsis-spec' : 'show-ellipsis-spec-len']" :title="node.label">{{ `${node.label}` }}</span>
            <template v-if="data.id == 0">
              <el-dropdown @command="handleCommand">
                <span class="el-dropdown-link">
                  <!-- <i class="el-icon-more" title="更多操作" /> -->
                  <img src="@/assets/img/iconMore.png" class="iconMore" />
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item icon="el-icon-plus" :command="{ node: node, data, action: 'addType' }">新增分类</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <template v-else-if="data.sub_type == 1">
              <el-dropdown @command="handleCommand">
                <span class="el-dropdown-link">
                  <!-- <i class="el-icon-more" title="更多操作" /> -->
                  <img src="@/assets/img/iconMore.png" class="iconMore" />
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item icon="el-icon-edit" :command="{ node: node, data, action: 'edit' }">编辑分类</el-dropdown-item>
                  <el-dropdown-item icon="el-icon-delete" :command="{ node: node, data, action: 'delete' }">删除分类</el-dropdown-item>
                  <el-dropdown-item icon="el-icon-plus" :command="{ node: node, data, action: 'add' }">新增模板</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <template v-else>
              <el-dropdown @command="handleCommand">
                <span class="el-dropdown-link">
                  <!-- <i class="el-icon-more" title="更多操作" /> -->
                  <img src="@/assets/img/iconMore.png" class="iconMore" />
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item icon="el-icon-edit" :command="{ node: node, data, action: 'dicEdit' }">编辑模板</el-dropdown-item>
                  <el-dropdown-item icon="el-icon-delete" :command="{ node: node, data, action: 'dicDelete' }">删除模板</el-dropdown-item>
                  <el-dropdown-item icon="el-icon-plus" :command="{ node: node, data, action: 'listAdd' }">新增列表</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </span>
        </fe-oa-template-tree>
      </el-aside>
      <el-container>
        <el-main class="fullheight">
          <el-scrollbar class="dic-data-scrollbar">
            <eco-tree
              :data="dicDatas"
              node-key="id"
              :props="defaultProps"
              :support-filter="false"
              :expand-on-click-node="false"
              :default-expand-all="isExpandDic"
              ref="dicDataTree"
            >
              <!-- 作用域插槽：插槽prop -->
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <span class="show-ellipsis" :title="node.label">{{ node.label }}</span>
                <el-dropdown @command="handleCommand" v-if="checkCanEdit()">
                  <span class="el-dropdown-link">
                    <!-- <i class="el-icon-more" title="更多操作" /> -->
                    <img src="@/assets/img/iconMore.png" class="iconMore" />
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item icon="el-icon-edit" v-if="data.sub_type == 3" :command="{ node: node, data, action: 'listEdit' }"
                      >编辑列表</el-dropdown-item
                    >
                    <el-dropdown-item icon="el-icon-delete" v-if="data.sub_type == 3" :command="{ node: node, data, action: 'listDel' }"
                      >删除列表</el-dropdown-item
                    >
                    <el-dropdown-item icon="el-icon-plus" v-if="data.sub_type == 3" :command="{ node: node, data, action: 'taskAdd' }"
                      >新增任务</el-dropdown-item
                    >
                    <el-dropdown-item icon="el-icon-plus" v-if="data.sub_type == 4" :command="{ node: node, data, action: 'taskEdit' }"
                      >编辑任务</el-dropdown-item
                    >
                    <el-dropdown-item icon="el-icon-plus" v-if="data.sub_type == 4" :command="{ node: node, data, action: 'taskDel' }"
                      >删除任务</el-dropdown-item
                    >
                  </el-dropdown-menu>
                </el-dropdown>
              </span>
            </eco-tree>
          </el-scrollbar>
        </el-main>
      </el-container>
      <!-- <div class="i_export">
        <el-button v-loading="loading" @click="addKey" v-if="checkCanEdit()"
          >新增类型</el-button
        >
      </div> -->
    </el-container>
    <!-- 添加分类 -->
    <eco-sidebar-dialog destroy-on-close width="28%" :title="title" :visible="dialogVisible" :before-close="handleClose" append-to-body>
      <el-form :model="oaTemplate" data-vv-scope="editSysTypeForm" style="padding: 20px">
        <eco-form-item label="分类名称" label-width="100px">
          <eco-input v-model="oaTemplate.name" autocomplete="off" :validate="{ required: true, max: 20 }"></eco-input>
        </eco-form-item>
      </el-form>
      <div class="demo-drawer__footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <fe-submit-button :url="saveOaTemplateUrl" :model="oaTemplate" scope-name="addTemplate" @after-save-data="afterSaveData">{{
          $t('eip.common.save')
        }}</fe-submit-button>
      </div>
    </eco-sidebar-dialog>
    <!-- 编辑分类 -->
    <eco-sidebar-dialog destroy-on-close width="28%" :title="title" :visible="dialogVisibleEdit" :before-close="handleClose" append-to-body>
      <el-form :model="oaTemplate" data-vv-scope="editSysTypeForm" style="padding: 20px">
        <eco-form-item label="分类名称" label-width="100px">
          <eco-input v-model="oaTemplate.name" autocomplete="off" :validate="{ required: true, max: 20 }"></eco-input>
        </eco-form-item>
      </el-form>
      <div class="demo-drawer__footer">
        <el-button @click="dialogVisibleEdit = false">取 消</el-button>
        <fe-submit-button :url="saveOaTemplateUrl" :model="oaTemplate" scope-name="editTemplate" requestMethod="PUT" @after-save-data="afterSaveData">{{
          $t('eip.common.save')
        }}</fe-submit-button>
      </div>
    </eco-sidebar-dialog>
    <!-- 添加模板 -->
    <eco-sidebar-dialog destroy-on-close width="28%" :title="title" :visible="dicDialogVisible" :before-close="handleClose" append-to-body>
      <el-form :model="dicData" data-vv-scope="editDic" style="padding: 20px">
        <eco-form-item label="分类名称" label-width="100px">
          <eco-input v-model="dicData.parentName" autocomplete="off" validate="required" disabled></eco-input>
        </eco-form-item>
        <eco-form-item label="模板名称" label-width="100px">
          <eco-input v-model="dicData.name" autocomplete="off" :validate="{ required: true, max: 10 }" placeholder="请输入模板名称" />
        </eco-form-item>
        <eco-form-item label="模板介绍" label-width="100px">
          <eco-input
            type="textarea"
            :autosize="{ minRows: 3 }"
            v-model="dicData.detail"
            autocomplete="off"
            :validate="{ required: true, max: 3000 }"
          ></eco-input>
        </eco-form-item>
        <eco-form-item label="状态" label-width="100px">
          <eco-radio
            validate="required"
            v-model="dicData.state"
            :options="[
              { key: 0, value: '启用' },
              { key: 1, value: '禁用' }
            ]"
          />
        </eco-form-item>
      </el-form>
      <div class="demo-drawer__footer">
        <el-button @click="dicDialogVisible = false">取 消</el-button>
        <fe-submit-button :url="saveOaTemplateUrl" :model="dicData" scope-name="addDic" @after-save-data="afterSaveDicData">{{
          $t('eip.common.save')
        }}</fe-submit-button>
      </div>
    </eco-sidebar-dialog>
    <!-- 编辑模板 -->
    <eco-sidebar-dialog destroy-on-close width="28%" :title="title" :visible="dicDialogVisibleEdit" :before-close="handleClose" append-to-body>
      <el-form :model="dicData" data-vv-scope="editDic" style="padding: 20px">
        <eco-form-item label="分类名称" label-width="100px">
          <eco-input v-model="dicData.parentName" autocomplete="off" validate="required" disabled></eco-input>
        </eco-form-item>
        <eco-form-item label="模板名称" label-width="100px">
          <eco-input v-model="dicData.name" autocomplete="off" :validate="{ required: true, max: 10 }" placeholder="请输入模板名称" />
        </eco-form-item>
        <eco-form-item label="模板介绍" label-width="100px">
          <eco-input
            type="textarea"
            :autosize="{ minRows: 3 }"
            v-model="dicData.detail"
            autocomplete="off"
            :validate="{ required: true, max: 3000 }"
          ></eco-input>
        </eco-form-item>
        <eco-form-item label="状态" label-width="100px">
          <eco-radio
            validate="required"
            v-model="dicData.state"
            :options="[
              { key: 0, value: '启用' },
              { key: 1, value: '禁用' }
            ]"
          />
        </eco-form-item>
      </el-form>
      <div class="demo-drawer__footer">
        <el-button @click="dicDialogVisibleEdit = false">取 消</el-button>
        <fe-submit-button :url="saveOaTemplateUrl" :model="dicData" scope-name="editDic" requestMethod="PUT" @after-save-data="afterSaveDicData">{{
          $t('eip.common.save')
        }}</fe-submit-button>
      </div>
    </eco-sidebar-dialog>
    <!-- 添加列表 -->
    <eco-sidebar-dialog destroy-on-close width="28%" :title="title" :visible="listDialogVisible" :before-close="handleClose" append-to-body>
      <el-form :model="listData" data-vv-scope="editDic" style="padding: 20px">
        <eco-form-item label="列表顺序" label-width="100px">
          <eco-input
            v-model="listData.sort"
            autocomplete="off"
            :validate="{
              required: true,
              regex: {
                exp: '^[0-9]*$',
                message: '请输入数字'
              }
            }"
          ></eco-input>
        </eco-form-item>
        <eco-form-item label="列表名称" label-width="100px">
          <eco-input v-model="listData.name" autocomplete="off" :validate="{ required: true, max: 10 }" placeholder="请输入列表名称" />
        </eco-form-item>
      </el-form>
      <div class="demo-drawer__footer">
        <el-button @click="listDialogVisible = false">取 消</el-button>
        <fe-submit-button :url="saveOaTemplateUrl" :model="listData" scope-name="addDic" @after-save-data="afterSaveListData">{{
          $t('eip.common.save')
        }}</fe-submit-button>
      </div>
    </eco-sidebar-dialog>
    <!-- 编辑列表 -->
    <eco-sidebar-dialog destroy-on-close width="28%" :title="title" :visible="listDialogVisibleEdit" :before-close="handleClose" append-to-body>
      <el-form :model="listData" data-vv-scope="editDic" style="padding: 20px">
        <eco-form-item label="列表顺序" label-width="100px">
          <eco-input
            v-model="listData.sort"
            autocomplete="off"
            :validate="{
              required: true,
              regex: {
                exp: '^[0-9]*$',
                message: '请输入数字'
              }
            }"
          ></eco-input>
        </eco-form-item>
        <eco-form-item label="列表名称" label-width="100px">
          <eco-input v-model="listData.name" autocomplete="off" :validate="{ required: true, max: 10 }" placeholder="请输入列表名称" />
        </eco-form-item>
      </el-form>
      <div class="demo-drawer__footer">
        <el-button @click="listDialogVisibleEdit = false">取 消</el-button>
        <fe-submit-button :url="saveOaTemplateUrl" :model="listData" scope-name="editDic" requestMethod="PUT" @after-save-data="afterSaveListData">{{
          $t('eip.common.save')
        }}</fe-submit-button>
      </div>
    </eco-sidebar-dialog>
    <!-- 添加任务 -->
    <eco-sidebar-dialog destroy-on-close width="28%" :title="title" :visible="taskDialogVisible" :before-close="handleClose" append-to-body>
      <el-form :model="taskData" data-vv-scope="editDic" style="padding: 20px">
        <eco-form-item label="列表名称" label-width="100px">
          <eco-input v-model="taskData.parent_name" autocomplete="off" validate="required" disabled></eco-input>
        </eco-form-item>
        <eco-form-item label="任务名称" label-width="100px">
          <eco-input v-model="taskData.name" autocomplete="off" :validate="{ required: true, max: 10 }" placeholder="请输入列表名称" />
        </eco-form-item>
        <eco-form-item label="任务详情" label-width="100px">
          <eco-input
            type="textarea"
            :autosize="{ minRows: 3 }"
            v-model="taskData.detail"
            autocomplete="off"
            :validate="{ required: false, max: 3000 }"
          ></eco-input>
        </eco-form-item>
      </el-form>
      <div class="demo-drawer__footer">
        <el-button @click="taskDialogVisible = false">取 消</el-button>
        <fe-submit-button :url="saveOaTemplateUrl" :model="taskData" scope-name="addDic" @after-save-data="afterSaveTaskData">{{
          $t('eip.common.save')
        }}</fe-submit-button>
      </div>
    </eco-sidebar-dialog>
    <!-- 编辑任务 -->
    <eco-sidebar-dialog destroy-on-close width="28%" :title="title" :visible="taskDialogVisibleEdit" :before-close="handleClose" append-to-body>
      <el-form :model="taskData" data-vv-scope="editDic" style="padding: 20px">
        <eco-form-item label="列表名称" label-width="100px">
          <eco-input v-model="taskData.parent_name" autocomplete="off" validate="required" disabled></eco-input>
        </eco-form-item>
        <eco-form-item label="任务名称" label-width="100px">
          <eco-input v-model="taskData.name" autocomplete="off" :validate="{ required: true, max: 10 }" placeholder="请输入列表名称" />
        </eco-form-item>
        <eco-form-item label="任务详情" label-width="100px">
          <eco-input
            type="textarea"
            :autosize="{ minRows: 3 }"
            v-model="taskData.detail"
            autocomplete="off"
            :validate="{ required: false, max: 3000 }"
          ></eco-input>
        </eco-form-item>
      </el-form>
      <div class="demo-drawer__footer">
        <el-button @click="taskDialogVisibleEdit = false">取 消</el-button>
        <fe-submit-button :url="saveOaTemplateUrl" :model="taskData" scope-name="editDic" requestMethod="PUT" @after-save-data="afterSaveTaskData">{{
          $t('eip.common.save')
        }}</fe-submit-button>
      </div>
    </eco-sidebar-dialog>
  </div>
</template>
<script>
import styles from '@/assets/css/element-variables.scss'
import oaTemplateAPi from '@/api/oaTemplate.js'
const FeOaTemplateTree = () => import('@/components/common/FeOaTemplateTree.vue')
export default {
  components: {
    FeOaTemplateTree
  },
  props: {
    width: {
      type: String,
      default: styles.aside_width
    },
    supportFilter: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      height: '100%',
      dicData: {
        key: '',
        name: '',
        detail: '',
        typeId: '',
        state: 0,
        sub_type: 2
      },
      editDicData: {},
      title: '新增模板',
      asideShow: true,
      isExpand: true,
      isExpandDic: true,
      dialogVisible: false,
      dialogVisibleEdit: false,
      dicDialogVisible: false,
      dicDialogVisibleEdit: false,
      listDialogVisibleEdit: false,
      listDialogVisible: false,
      taskDialogVisibleEdit: false,
      taskDialogVisible: false,
      fullscreenLoading: false,
      fileList: [],
      oaTemplate: {
        name: '',
        state: 0,
        sub_type: 1
      },
      referType: {
        name: ''
      },
      parentSysType: {
        name: ''
      },
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      data: [],
      pageResult: {
        page: 1,
        pageSize: 20,
        total: 0
      },
      bpmForm: {
        key: '',
        bos: '',
        desc: ''
      },
      dicDatas: [],
      loading: false,
      maxlength: 20,
      tenantId: '',
      listData: {
        sort: '',
        name: '',
        parent_id: '',
        sub_type: 3
      },
      taskData: {
        parent_name: '',
        name: '',
        parent_id: '',
        detail: '',
        sub_type: 4
      },
      last_tree_id: ''
    }
  },
  computed: {
    saveOaTemplateUrl: function () {
      return `${window.context.business}/oa/oa_task_template/`
    },
    saveReferTypeUrl: function () {
      return `${window.context.business}/system/cost_account_template_type/quote/`
    },
    saveDicDataUrl: function () {
      return `${window.context.business}/system/cost_account_template/`
    }
  },
  mounted() {
    this.tenantId = typeof sessionStorage.getItem('tenantId') == 'undefined' ? sessionStorage.getItem('tenantId') : sessionStorage.getItem('currentTenantId')
    this.height = this.tenantId && this.tenantId != -1 ? 'calc(100% - 56px)' : '100%'
  },
  methods: {
    handleNodeClick(node) {
      this.last_tree_id = ''
      if (node.sub_type == 2) {
        this.last_tree_id = node.id
        this.dicLoadData(node.id)
      }
    },
    setTree(val) {
      this.treeData = val
    },
    dicLoadData(id) {
      oaTemplateAPi.getTemplateList(id).then((res) => {
        this.dicDatas = res.value.children
      })
    },
    handleCommand(command) {
      let data = command.data
      let action = command.action
      let newDicdata
      switch (action) {
        case 'addType':
          this.oaTemplate.id = ''
          this.title = '新增分类'
          this.dialogVisible = true
          break
        case 'add':
          this.title = '新增模板'
          this.dicData = {
            key: '',
            name: '',
            detail: '',
            typeId: '',
            state: 0,
            sub_type: 2,
            parentName: data.name,
            parent_id: data.id
          }
          //   this.dicData.parentName = data.name;
          //   this.dicData.parent_id = data.id;
          //   this.dicData.state = 0;
          this.dicDialogVisible = true
          break
        case 'edit':
          newDicdata = {}
          this.title = '编辑分类'
          //克隆一个对象 以免数据与树动态绑定
          Object.assign(newDicdata, data)
          this.oaTemplate = newDicdata
          this.dialogVisibleEdit = true
          break
        case 'delete':
          if (data.children && data.children.length > 0) {
            this.$message.error('请确认此分类下没有模板！')
          } else {
            oaTemplateAPi.delOaTemplate(data.id).then((res) => {
              if (res.state) {
                this.$message.info('删除成功！')
                this.$refs.ecoDataDicTree.loadData()
              }
            })
          }
          break
        case 'dicAdd': //数据字典添加
          this.title = '添加模板'
          this.dicDialogVisible = true
          this.dicData.name = ''
          this.dicData.key = ''
          this.dicData.parent_key = data.key
          this.dicData.parentName = data.name
          this.dicData.refId = data.refId
          break
        case 'dicEdit':
          newDicdata = {}
          this.title = '编辑模板'
          //克隆一个对象 以免数据与树动态绑定
          Object.assign(newDicdata, data)
          this.dicData = newDicdata
          this.dicDialogVisibleEdit = true
          break
        case 'dicDelete':
          if (data.id) {
            this.$confirm(`是否确定删除 [${data.name}] ?`, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              oaTemplateAPi
                .delOaTemplate(data.id)
                .then((data) => {
                  if (data.state) {
                    this.$message({
                      type: 'success',
                      message: data.message || '删除成功'
                    })
                    this.$refs.ecoDataDicTree.loadData()
                  } else {
                    this.$message.error(data.message || '删除成功')
                  }
                })
                .catch(() => {
                  this.dicDialogVisible = false
                })
            })
          }
          break
        case 'listAdd':
          this.listData = {
            sort: '',
            name: '',
            parent_id: data.id,
            sub_type: 3
          }
          this.title = '新增列表'
          this.listDialogVisible = true
          break
        case 'listEdit':
          newDicdata = {}
          this.title = '编辑列表'
          //克隆一个对象 以免数据与树动态绑定
          Object.assign(newDicdata, data)
          this.listData = newDicdata
          this.listDialogVisibleEdit = true
          break
        case 'listDel':
          oaTemplateAPi.delOaTemplate(data.id).then((res) => {
            if (res.state) {
              this.$message.info('删除成功！')
              this.dicLoadData(data.parent_id)
            }
          })
          break
        case 'taskAdd':
          this.taskData = {
            parent_name: data.name,
            name: '',
            parent_id: data.id,
            detail: '',
            sub_type: 4
          }
          this.title = '新增任务'
          this.taskDialogVisible = true
          break
        case 'taskEdit':
          newDicdata = {}
          this.title = '编辑任务'
          //克隆一个对象 以免数据与树动态绑定
          Object.assign(newDicdata, data)
          this.taskData = newDicdata
          this.taskDialogVisibleEdit = true
          break
        case 'taskDel':
          oaTemplateAPi.delOaTemplate(data.id).then((res) => {
            if (res.state) {
              this.$message.info('删除成功！')
              this.dicLoadData(this.last_tree_id)
            }
          })
          break
        default:
          break
      }
    },
    handleReferClose() {
      this.referVisible = false
    },
    handleClose() {
      this.dialogVisible = false
      this.dialogVisibleEdit = false
      this.dicDialogVisible = false
      this.dicDialogVisibleEdit = false
      this.listDialogVisibleEdit = false
      this.listDialogVisible = false
      this.taskDialogVisibleEdit = false
      this.taskDialogVisible = false
    },
    handleCloseEdit() {
      this.editDicDialogVisible = false
    },
    afterSaveData() {
      this.$refs.ecoDataDicTree.loadData()
      if (this.oaTemplate.id) {
        this.dialogVisibleEdit = false
        return
      }
      this.oaTemplate.name = ''
      this.$confirm('是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'success'
      })
        .then(() => {})
        .catch(() => {
          this.dialogVisible = false
        })
    },
    afterSaveRefData() {
      this.$refs.ecoDataDicTree.loadData()
      this.referVisible = false
    },
    afterSaveDicData() {
      this.$refs.ecoDataDicTree.loadData()
      if (this.dicData.id) {
        this.dicDialogVisibleEdit = false
        return
      }
      this.dicData.name = ''
      this.dicData.detail = ''
      this.$confirm('是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'success'
      })
        .then(() => {})
        .catch(() => {
          this.dicDialogVisible = false
        })
    },
    afterSaveListData() {
      this.$refs.ecoDataDicTree.loadData()
      if (this.listData.id) {
        this.dicLoadData(this.listData.parent_id)
        this.listDialogVisibleEdit = false
        return
      }
      this.listData.name = ''
      this.listData.sort = ''
      this.$confirm('是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'success'
      })
        .then(() => {})
        .catch(() => {
          this.listDialogVisible = false
        })
    },
    afterSaveTaskData() {
      this.$refs.ecoDataDicTree.loadData()
      this.dicLoadData(this.last_tree_id)
      if (this.taskData.id) {
        this.taskDialogVisibleEdit = false
        return
      }
      this.taskData.name = ''
      this.taskData.detail = ''
      this.$confirm('是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'success'
      })
        .then(() => {})
        .catch(() => {
          this.taskDialogVisible = false
        })
    },
    beforeUpload() {
      this.fullscreenLoading = true
    },
    submitImport() {
      if (!this.$refs.upload.uploadFiles || this.$refs.upload.uploadFiles.length == 0) {
        this.$message.warning('请上传数据字典文件进行导入')
        return false
      }
      if (this.oaTemplate.id && this.oaTemplate.id == '') {
        this.$message.warning('请选择某一个分类进行导入!')
      }
      this.$refs.upload.submit()
    },
    cancelConfirm() {
      this.$refs.upload.clearFiles()
      this.fileList = []
      this.dialogImportVisible = false
    },
    //下载模板
    downloadTemplate() {
      window.location.href = '/static/excel/数据字典模板.xls'
    },
    /**
     * 判断是否能编辑
     */
    checkCanEdit() {
      return true
    }
  }
}
</script>

<style lang="scss" scoped>
.el-main {
  padding: 0px;
}
>>> .navbar-collapse {
  position: absolute;
  top: 41%;
  cursor: pointer;
  z-index: 999;
  width: 20px;
}

>>> .el-dropdown {
  display: none;
}

>>> .el-tree-node__content:hover .el-dropdown {
  display: inline-block;
}

>>> .navbar-collapse:hover {
  transform: scale(1.1) translateY(2px);
}

>>> .navbar-collapse:hover .navbar-collapse-arrow {
  color: #333333;
}

>>> .navbar-collapse-arrow {
  position: absolute;
  top: 38%;
  right: -3px;
  font-size: 18px;
  color: #a8a8a8;
}

>>> .navbar-collapse-bg {
  -webkit-transition: all 0.12s ease;
  height: 50px;
  border-bottom: 8px solid transparent;
  border-right: none;
  border-left: 12px solid #ebebeb;
  border-top: 8px solid transparent;
  opacity: 0.9;
}
.el-aside-footer {
  position: absolute;
  bottom: 21px;
}
.i_export {
  margin-top: 15px;
  margin-right: 15px;
}
>>> .custom-tree-node {
  width: calc(100% - 40px);
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

.custom-tree-node i {
  visibility: hidden;
  font-weight: bold;
}

.custom-tree-node:hover i {
  visibility: visible;
}

.dic-data-scrollbar {
  width: 250px;
  height: 100%;
  border-right: 1px solid #eee;
}

.dic-data-scrollbar >>> .el-scrollbar__wrap {
  overflow-x: hidden;
}
.show-ellipsis-spec {
  width: calc(100% - 52px);
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.show-ellipsis-spec-len {
  width: calc(100% - 25px);
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.custom-tree-node {
  width: calc(100% - 40px);
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: left;
  font-size: 14px;
  padding-right: 8px;
}
/deep/.aa > .el-tabs__header {
  margin: 0;
}
</style>
<style>
.oaTemplate {
  padding: 16px 0 0;
  height: calc(100% - 20px);
}
.oaTemplate .show-ellipsis-spec {
  width: calc(100% - 22px) !important;
}
</style>
